export const clubCategoryData = [
    {key: 'cultural', text: 'Arts & Culture', value: 'Arts & Culture'},
    {key: 'scienceNtechnology', text: 'Science & Technology', value: 'Science & Technology'},
    {key: 'sports', text: 'Sports', value: 'Sports'},
    {key: 'social', text: 'Social', value: 'Social'},
];